module.exports = __webpack_public_path__ + "static/media/ButtonPlusOrange.668aba45.png";